// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"58ff75d0","933":"1bdfa765"}[chunkId] + ".chunk.css";
};